import type { NeonMode } from '@art-basel/artbasel-lib-neon';
import { NeonModeUtils } from '@art-basel/artbasel-lib-neon';
import { defineStore } from 'pinia';

interface ModeState {
  mode: NeonMode;
}

interface ModeActions {
  setMode(newMode: NeonMode): void;
  loadModeFromNeonUtils(): void;
  reset(): void;
}

export const useModeStore = defineStore<string, ModeState, Record<string, never>, ModeActions>('modeStore', {
  state: (): ModeState => ({
    mode: NeonModeUtils.getMode(),
  }),
  getters: {},
  actions: {
    setMode(newMode: NeonMode) {
      this.mode = newMode;

      NeonModeUtils.switchMode(newMode);
    },

    // Action to load mode from NeonModeUtils
    loadModeFromNeonUtils() {
      const modeFromUtils = NeonModeUtils.getMode();
      if (modeFromUtils) {
        this.mode = modeFromUtils;
      }
    },

    /**
     * Reset the store to its initial state
     */
    reset() {
      this.mode = NeonModeUtils.getMode();
    },
  },
});
